var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86364 25H21.3788C21.8557 25 22.2424 24.6133 22.2424 24.1364V14.3485C22.2424 13.8715 21.8557 13.4848 21.3788 13.4848H20.5152V10.8939C20.5152 8.19542 18.3197 6 15.6212 6C12.9227 6 10.7273 8.19542 10.7273 10.8939V13.4848H9.86364C9.38668 13.4848 9 13.8715 9 14.3485V24.1364C9 24.6133 9.38668 25 9.86364 25ZM18.0671 18.6296L15.6201 21.0766C15.4515 21.2452 15.2304 21.3295 15.0095 21.3295C14.7885 21.3295 14.5674 21.2452 14.3988 21.0766L13.1753 19.8531C12.8381 19.5158 12.8381 18.9691 13.1753 18.6317C13.5126 18.2944 14.0594 18.2944 14.3967 18.6317L15.0095 19.2445L16.8458 17.4082C17.1831 17.071 17.7299 17.071 18.0672 17.4082C18.4044 17.7456 18.4044 18.2923 18.0671 18.6296ZM12.4545 10.8939C12.4545 9.14784 13.8751 7.72727 15.6212 7.72727C17.3673 7.72727 18.7879 9.14784 18.7879 10.8939V13.4848H12.4545V10.8939Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesFive);
export default __webpack_public_path__ + "static/media/features-five.0ea86b20.svg";
export { ForwardRef as ReactComponent };